import { render, staticRenderFns } from "./ServiceListVue.vue?vue&type=template&id=c1f0b788&scoped=true"
import script from "./ServiceListVue.vue?vue&type=script&lang=js"
export * from "./ServiceListVue.vue?vue&type=script&lang=js"
import style0 from "./ServiceListVue.vue?vue&type=style&index=0&id=c1f0b788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f0b788",
  null
  
)

export default component.exports